export default [
  {
    path: "/9U4UqG",
    children: [
      {
        path: "/G6g3Ot1",
        name: "zonaldoList",
        meta: {
          title: "Zonal DOs",
          authRequired: true,
          acc: ["y17618"],
        },
        component: () => import("../views/zonaldo/list.vue"),
      },
      {
        path: "/MmjxWkI9X7/:tr?",
        name: "viewZonaldo",
        meta: {
          title: "View Zonal DO",
          authRequired: true,
          acc: ["y82554"],
        },
        component: () => import("../views/zonaldo/view.vue"),
      },
      {
        path: "/6aMuFbh7x4/:tr?",
        name: "updateZonaldo",
        meta: {
          title: "Update Zonal DO",
          authRequired: true,
          acc: ["y37080"],
        },
        component: () => import("../views/zonaldo/update.vue"),
      },
      {
        path: "/pdp4K8ff/:tr?",
        name: "updateZonaldoPassword",
        meta: {
          title: "Update Zonal DO Password",
          authRequired: true,
          acc: ["y37080"],
        },
        component: () => import("../views/zonaldo/updatePassword.vue"),
      },
      {
        path: "/0eWIXiiQE/:tr?",
        name: "updateZonaldoRole",
        meta: {
          title: "Update Zonal DO Role",
          authRequired: true,
          acc: ["y37080"],
        },
        component: () => import("../views/zonaldo/updateRole.vue"),
      },
      {
        path: "/kqH3MB9n7I",
        name: "newZonaldo",
        meta: {
          title: "New Zonal DO",
          authRequired: true,
          acc: ["y17618"],
        },
        component: () => import("../views/zonaldo/new.vue"),
      },
      {
        path: "/kqH3084ce857ad09b2c5bcf90b99MB9n7I",
        name: "assign.z.officer",
        meta: {
          title: "Assign Zonal Officer",
          authRequired: true,
          acc: ["y45036"],
        },
        component: () => import("../views/zonaldo/assign.vue"),
      },
      {
        path: "/kqH089330af9de617f8222a3385n7I",
        name: "assigned.z.officer",
        meta: {
          title: "Assigned Zonal Officer",
          authRequired: true,
          acc: ["y45008"],
        },
        component: () => import("../views/zonaldo/assigned.vue"),
      },
    ],
  },
];
